// extracted by mini-css-extract-plugin
module.exports = {"buttonOutline":"button_buttonOutline__Cq2Ip","emptybtn":"button_emptybtn__2isVo","primaryButton":"button_primaryButton__25djA"};